import { gql } from "@apollo/client";

export const CHECK_BOOKING_CONFIRMATION_ELIGIBILITY = gql`
  query bookingConfirmationEligibility($bookingId: String!, $bookingType: String) {
    bookingConfirmationEligibility(bookingId: $bookingId, bookingType: $bookingType)
  }
`;